<template>
<div class="content">
  <van-notice-bar color="#fff" background="#333" style="font-size: 3.2vw" :scrollable="false" left-icon="info-o">
    微信提示：您提交的重要信息，我公司将严格保护。
  </van-notice-bar>
  <img class="logo" src="../../assets/logo.png" alt="" />
  <div class="list-box">
    <div class="title">用户登录</div>
    <div class="item-box">
      <div class="name">手机号码</div>
      <input v-model="mobile" maxlength="11" placeholder="请输入手机号码" type="number" />
    </div>
    <div class="item-box">
      <div class="name">登录密码</div>
      <input v-model="password" placeholder="请输入登录密码" type="text" />
    </div>

  </div>
  <van-button @click="onSubmit" color="#ea5e2d" style="width: 80%;margin: 4vw auto;" type="primary" round>登录</van-button>
<!--  <div class="remember-info left-justifying"><van-checkbox v-model="checked" checked-color="#ea5e2d" shape="square">记住账号信息</van-checkbox></div>-->
  <div class="link-box">
    <router-link to='/consumerRegister'>
      <div class="register">立即注册</div>
    </router-link>

<!--    <div class="register">忘记密码</div>-->
  </div>
</div>
</template>

<script>
let Base64 = require('js-base64').Base64
import storage from '../../utils/storage' // 引入封装的 函数
import { Dialog,Toast } from 'vant'
import axios from 'axios'
export default {
  name: 'login',
  data() {
    return {
      checked: false,
      mobile: '',
      password: '',
      info: '',
      loading: true,
      errored: false
    };
  },
  created:function(){
    this.goCode()
  },
  methods: {
    goCode(){
      // 获取存储的token的值  有的话 赋值 isLogin 为true 否则 false
      const terminalToken = localStorage.getItem('terminalToken')
      var accountOpenState = localStorage.getItem('accountOpenState')
      console.log('terminalToken', terminalToken)
      if (terminalToken != null){ // 非等于空
        var tokenInfo = JSON.parse(terminalToken)
        // 获取当前时间
        let nows = new Date().getTime();
        console.log('new',nows);
        if (nows - tokenInfo.startTime > tokenInfo.expires) {
          console.log('时间到期留在这里登录')
          localStorage.removeItem('terminalToken');
          localStorage.removeItem('accountOpenState');
          // this.$router.push('/consumerLogin');
        } else { // 没到时间
          var TokenInfo = JSON.parse(terminalToken)
          var stateInfo = JSON.parse(accountOpenState)
          console.log('没到时间 ')
          var str= 'https://jpzs.itos.cn/Wechat/Member/index.html'
          var result = Base64.encode(str);
          console.log(result)
          var url = 'https://m.bte.group/jump/terminalToken/'+TokenInfo.value+'/accountOpenState/'+ stateInfo.value+'/returnUrl/'+result
          // console.log(url)
          window.location.href = url
        }
      } else { // 没有就显示登录界面
        // this.$router.push('/consumerLogin');
      }
    },
    onSubmit(){
      if(this.mobile == ''){
        Toast('手机号码');
        return false
      } else if (this.password == ''){
        Toast('密码');
        return false
      }
      var data = {
        mobile: this.mobile,
        password: this.password
      }
      Toast.loading({
        mask: false,
        duration: 0, // 一直存在
        forbidClick: true, // 禁止点击
        message: '加载中...'
      })
      axios.post('https://mapi.bte.group/member/passport/signin',data)
        .then(response => {
          Toast.clear()
          var res = response.data
          console.log(res.message)
          if (res.message = 'ok'){

            // 这里我是把登录返回的token放入了进去 同时设置了过期时间 10s
            storage.setItem({value:res.data.terminalToken,name:'terminalToken',expires:2592000000})//存储 过期时间是毫秒 我这里是30天
            storage.setItem({value:res.data.accountOpenState,name:'accountOpenState',expires:2592000000}) //存储 过期时间是毫秒 我这里是30天

            this.$toast.success('登录成功!')
            var str= 'https://jpzs.itos.cn/Wechat/Member/index.html'
            var result = Base64.encode(str);
            var url = 'https://m.bte.group/jump/terminalToken/'+res.data.terminalToken+'/accountOpenState/'+res.data.accountOpenState+'/returnUrl/'+result
            window.location.href = url
          }
        }).catch(error => {
        Toast.clear()
          console.log(error)
          Toast(error.response.data.message);
        })
        .finally(() => this.loading = false)

    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  text-align: center;
}
.logo{
  width: 100%;height: auto;display: block;margin: 30px auto;
}
.list-box{
  font-size: 28px;
  .title{
    font-size: 42px;color: #666;
  }
  .item-box{
    text-align: left;padding: 10px 24px;
    .name{
      padding-bottom: 10px;
    }
    input{
      border: none;
      border-bottom: 1px solid #f5f5f5; width: 100%;height: 60px;line-height: 60px;
    }
  }
}
.remember-info{
  font-size: 26px;width: 80%;margin: 20px auto 40px;
}
.link-box{
  font-size: 28px;width: 40%;margin: 0 auto;color: #ea5e2d;
  .register{
    color: #ea5e2d;text-decoration:underline;
  }
}
</style>
